<template>
    <div id="dialogAppointment">
        <Dialog ref="dialog"
                :visible="visible"
                :dialog="dialogs"
                :mFormValue="formData"
                :defaultModalVal="false"
                :showTimePick="showTimePick"
                @closeDialog="closeDialog"
                @carDialogCheck="carDialogCheck"
        >
            <template slot="formHeader">
                <el-row>
                    <el-col :span="5">任务号:</el-col>
                    <el-col :span="18" class="ml">{{appointmentData.taskNo}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5">客户订单号:</el-col>
                    <el-col :span="18" class="ml">{{appointmentData.customerOrderNo}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5">收件人信息:</el-col>
                    <el-col :span="18" class="ml">{{appointmentData.receiveMessage}}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5">客户期望送达:</el-col>
                    <el-col :span="18" class="ml">{{appointmentData.expectTime}}</el-col>
                </el-row>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Dialog from '../dialog/dialog';
import { getDictionaryDetailByCode } from '../../api/common';

export default {
    components: { Dialog },
    data() {
        return {
            visible: false,
            formData: {},
            value: null,
            dialogs: {
                'type': 'date',
                'title': '预约',
                'dateType': 'future',
                'detailTime': '23:59:59',
                'width': '1000px',
                'hideFooter': true,
                'hideTable': true,
                'dayHeight': '20px',
                'dateConnect': 'appointTime',
                'calendarWidth': '30%',
                'formBoxWidth': '70%',
                'btnList': [{
                    'type': 'negative',
                    'text': '重置'
                }, {
                    'type': 'sure',
                    'text': '保存'
                }],
                'dialogForm': {
                    'inline': false,
                    'labelWidth': 7,
                    'inputWidth': 15,
                    'inputList': [{
                        'label': '预约时间',
                        'value': 'appointTime',
                        'prop': 'appointTime',
                        'placeholder': '预约时间',
                        'readOnly': true,
                        'span': 12,
                        'type': 'readonlyText'
                    }, {
                        'label': '改约一级原因',
                        'prop': 'appointReason',
                        'value': 'appointReason',
                        'readOnly': true,
                        'placeholder': '请选择',
                        'span': 12,
                        'type': 'dictionary',
                        'optionNum': 'OTP_CHANGE_RESERVATION_TYPE'
                    }, {
                        'label': '预约类型',
                        'prop': 'appointType',
                        'value': 'appointType',
                        'mustFill': true,
                        'readOnly': true,
                        'placeholder': '请选择',
                        'options': [],
                        'span': 12,
                        'type': 'dictionary'
                    }, {
                        'label': '改约二级原因',
                        'prop': 'secendAppointReason',
                        'value': 'secendAppointReason',
                        'readOnly': true,
                        'placeholder': '请选择',
                        'span': 12,
                        'type': 'dictionary',
                        'options': []
                    }, {
                        'label': '预约异常类型',
                        'prop': 'exceptionType',
                        'value': 'exceptionType',
                        'readOnly': false,
                        'placeholder': '请选择',
                        'span': 12,
                        'type': 'dictionary',
                        'optionNum': 'CAINIAO_WMS_ERROR'
                    }, {
                        'label': '备       注',
                        'prop': 'remark',
                        'value': 'remark',
                        'placeholder': '备注',
                        'span': 12,
                        'type': 'text'
                    }, {
                        'label': '被回访人',
                        'prop': 'revisiter',
                        'value': 'revisiter',
                        'placeholder': '被回访人',
                        'isShowRelyOn': { 'secendAppointReason': '20_01|20_02|20_04|20_05' },
                        'isShow': false,
                        'isHideShow': true,
                        'mustFill': true,
                        defaultFill: true,
                        'span': 12,
                        'type': 'text'
                    }, {
                        'label': '被回访人电话',
                        'prop': 'revisiterMobile',
                        'value': 'revisiterMobile',
                        'placeholder': '被回访人电话',
                        'isShowRelyOn': { 'secendAppointReason': '20_01|20_02|20_04|20_05' },
                        'isShow': false,
                        'isHideShow': true,
                        'mustFill': true,
                        defaultFill: true,
                        'span': 12,
                        'type': 'text'
                    }]
                }
            }
        };
    },
    created() {
        if (!sessionStorage.OTP_SYS_TMS_MARK_SH) {
            this.getSecendAppointReason();
        }
    },
    methods: {
        // 获取二级逾期原因
        getSecendAppointReason() {
            getDictionaryDetailByCode({ dictCodes: 'OTP_SYS_TMS_MARK_SH' }).then(res => {
                if (res) {
                    sessionStorage.setItem('OTP_SYS_TMS_MARK_SH', JSON.stringify(res.data.OTP_SYS_TMS_MARK_SH));
                }
            }).catch(() => {
            });
        },
        carDialogCheck(value, col) {
            if (col.value === 'appointReason') {
                this.formData = { ...this.formData, ...value, taskNo: this.appointmentData.taskNo, secendAppointReason: '' };
                this.dialogs.dialogForm.inputList[3].options = [];
                this.dialogs.dialogForm.inputList[6].isShow = false;
                this.dialogs.dialogForm.inputList[7].isShow = false;
                if (value.appointReason) {
                    const filterKey = value.appointReason + '_';
                    const OTP_SYS_TMS_MARK_SH = JSON.parse(sessionStorage.getItem('OTP_SYS_TMS_MARK_SH'));
                    this.dialogs.dialogForm.inputList[3].options = Object.entries(OTP_SYS_TMS_MARK_SH).map(item => ({ value: item[0], label: item[1] })).filter(item => {
                        return item.value.indexOf(filterKey) === 0;
                    });
                }
            }
        },
        showDialog() {
            this.$refs.dialog.setDayHeight('40px');
            this.visible = true;
        },
        closeDialog(value, type) {
            const formData = { ...this.formData, ...value, taskNo: this.appointmentData.taskNo };
            this.$emit('closeDialog', formData, type);
        }
    },
    props: {
        appointmentData: {
            type: Object,
            default() {
                return {
                    taskNo: '',
                    customerOrderNo: '',
                    receiveMessage: '',
                    expectTime: ''
                };
            }
        },
        showTimePick: Boolean
    }
};
</script>

<style lang="less">
    #dialogAppointment{
        .ml{
            margin-left:10px;
        }
    }

</style>